<section class="team" id="our-team" #root aria-labelledby="team-title">
  <!-- ============================================================
       AMBIENT BACKGROUND
       ============================================================ -->
  <div class="team__bg" aria-hidden="true">
    <span class="team__blob team__blob--pink"></span>
    <span class="team__blob team__blob--violet"></span>
    <span class="team__blob team__blob--blue"></span>

    <!-- orbital circles -->
    <svg class="team__orbit team__orbit--l" viewBox="0 0 400 400" fill="none">
      <circle cx="200" cy="200" r="196" stroke="url(#teamOrbA)" stroke-width="1" />
      <circle cx="200" cy="200" r="148" stroke="url(#teamOrbA)" stroke-width="1" stroke-opacity=".6" />
      <circle class="team__orbit-dot" cx="200" cy="4" r="5" fill="#ff3e9d" />
      <defs>
        <linearGradient id="teamOrbA" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#ff3e9d" stop-opacity=".4" />
          <stop offset="100%" stop-color="#9b5cff" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <svg class="team__orbit team__orbit--r" viewBox="0 0 400 400" fill="none">
      <circle cx="200" cy="200" r="180" stroke="url(#teamOrbB)" stroke-width="1" />
      <circle class="team__orbit-dot team__orbit-dot--2" cx="380" cy="200" r="4" fill="#4d7cfe" />
      <defs>
        <linearGradient id="teamOrbB" x1="1" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#4d7cfe" stop-opacity=".42" />
          <stop offset="100%" stop-color="#ff3e9d" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <!-- thin drifting curves -->
    <svg class="team__curves" viewBox="0 0 1440 900" preserveAspectRatio="none" fill="none">
      <path class="team__curve" d="M-40 240C300 160 620 300 940 200s360-140 580-60" stroke="url(#teamCurve)" stroke-width="1.2" />
      <path class="team__curve team__curve--2" d="M-40 700C320 620 600 780 920 680s400-120 600-40" stroke="url(#teamCurve)" stroke-width="1" />
      <defs>
        <linearGradient id="teamCurve" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%" stop-color="#ff3e9d" stop-opacity="0" />
          <stop offset="50%" stop-color="#9b5cff" stop-opacity=".34" />
          <stop offset="100%" stop-color="#4d7cfe" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>

    <!-- stars + glowing dots -->
    <span class="team__stars">
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
      <i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i>
    </span>

    <span class="team__dotfield team__dotfield--l"></span>
    <span class="team__dotfield team__dotfield--r"></span>
  </div>

  <div class="container team__inner">
    <!-- ============================================================
         HEADER
         ============================================================ -->
    <header class="team__head" #head>
      <span class="team__badge">
        <svg class="team__badge-star" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="m12 2.6 2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.7l-5.9 3.1 1.2-6.6L2.5 9.6l6.6-.9z" />
        </svg>
        OUR CULTURE
      </span>

      <h2 class="team__title" id="team-title">
        Meet The People Behind
        <span class="team__title-grad">Innovation</span>
      </h2>

      <span class="team__divider" aria-hidden="true">
        <i></i><em></em><i></i>
      </span>

      <p class="team__lede">
        A passionate team of designers, developers and innovators building
        world-class digital experiences.
      </p>
    </header>

    <!-- ============================================================
         MAGAZINE GALLERY
         ============================================================ -->
    <ul class="team__grid" #grid>
      <li
        class="team__card"
        *ngFor="let s of shots; trackBy: trackShot"
        #card
        [ngClass]="'team__card--' + s.slot"
        tabindex="0"
      >
        <!-- parallax lives here, hover lift on the card -->
        <span class="team__shift">
          <span class="team__frame">
            <img
              class="team__img"
              [src]="s.img"
              [alt]="s.alt"
              loading="lazy"
              decoding="async"
            />
            <span class="team__scrim" aria-hidden="true"></span>
            <span class="team__edge" aria-hidden="true"></span>
          </span>

          <!-- glass caption, rises on hover -->
          <span class="team__cap">
            <span class="team__cap-ico" aria-hidden="true">
              <ng-container [ngSwitch]="s.icon">
                <svg *ngSwitchCase="'users'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="9" cy="8" r="3.2" /><path d="M2.8 19a6.2 6.2 0 0 1 12.4 0" />
                  <path d="M16.5 5.5a3.2 3.2 0 0 1 0 5.6M18 19a6 6 0 0 0-2-4.4" />
                </svg>
                <svg *ngSwitchCase="'monitor'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="2.5" y="4" width="19" height="13" rx="2.2" /><path d="M9 21h6M12 17v4" />
                </svg>
                <svg *ngSwitchCase="'chat'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.5 12a7.5 7.5 0 0 1-11 6.6L4 20l1.4-4.2A7.5 7.5 0 1 1 20.5 12z" />
                </svg>
                <svg *ngSwitchCase="'group'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="7.5" cy="9" r="2.6" /><circle cx="16.5" cy="9" r="2.6" />
                  <path d="M2.6 18a5 5 0 0 1 9.8 0M11.6 18a5 5 0 0 1 9.8 0" />
                </svg>
                <svg *ngSwitchCase="'star'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m12 3.4 2.6 5.4 5.9.8-4.3 4.2 1 5.9L12 17l-5.2 2.7 1-5.9-4.3-4.2 5.9-.8z" />
                </svg>
                <svg *ngSwitchCase="'heart'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 20s-7.5-4.6-7.5-9.5A4.2 4.2 0 0 1 12 8a4.2 4.2 0 0 1 7.5 2.5C19.5 15.4 12 20 12 20z" />
                </svg>
                <svg *ngSwitchCase="'crown'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="m3 7 4 4 5-6 5 6 4-4-2 12H5z" />
                </svg>
                <svg *ngSwitchDefault viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M13 2.5 4.5 13.5H11l-.5 8 8.5-11H13z" />
                </svg>
              </ng-container>
            </span>

            <span class="team__cap-meta">
              <b>{{ s.title }}</b>
              <u>{{ s.copy }}</u>
            </span>
          </span>
        </span>
      </li>
    </ul>

    <!-- ============================================================
         BOTTOM CTA
         ============================================================ -->
    <div class="team__cta">
      <span class="team__cta-ico" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="9" cy="8" r="3.2" /><path d="M2.8 19a6.2 6.2 0 0 1 12.4 0" />
          <path d="M16.5 5.5a3.2 3.2 0 0 1 0 5.6M18 19a6 6 0 0 0-2-4.4" />
        </svg>
      </span>

      <span class="team__cta-copy">
        <b>Stronger <span class="team__cta-grad">Together</span></b>
        <u>Great software is built by great teams working together.</u>
      </span>

      <a class="team__cta-btn" routerLink="/careers">
        Join Our Journey
        <i aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </i>
      </a>
    </div>
  </div>
</section>
